var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"data41"},[_c('div',{staticClass:"data41Til"},[_vm._v(_vm._s(_vm.list.data.menuTitle))]),_c('div',{staticClass:"data41Box"},_vm._l((_vm.list.data.cover),function(item,index){return _c('div',{key:index,staticClass:"data41BoxFor"},[(_vm.list.data.type==2)?_c('img',{style:({
				width:'375px',
				height:'260px'
			}),attrs:{"src":item}}):_c('img',{style:({
				width:'375px',
				height:'375px'
			}),attrs:{"src":item}})])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }